import React from "react";
import styles from "./result.module.css";
import {Page} from "../../components/page/page";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";
import {cardImages} from "../choose-cards/images_data";
import { getPaywallPage } from "src/shared/utils/get-paywall-page";
import { removeLocalStorage, StorageKey } from "src/shared/utils/localStorages";

const ResultPage = () => {
    const guestId = useSelector((store) => store.guestId);
    // const resultLink = `https://front-dev.zodiaq.vip/horoscopes?userId=${guestId}&source=tarot`;
    // TODO брать аргумент для getPaywallPage из LS
    const paywallPage = getPaywallPage('tarot')
    const resultLink = `https://zodiaq.vip/${paywallPage}?userId=${guestId}&source=tarot`;

    const handleContinue = () => {
        removeLocalStorage(StorageKey.UserId);
      };

    const state = useSelector((store) => store.tarot);
    return (
        <Page title="Love Tarot Reading" hideContinueButton={true} onContinue={handleContinue}>
            {state.cards.map((cardId, _) => (
                <div className={styles.item_container}>
                    <img
                        src={cardImages[cardId]}
                        className={styles.card_image}
                        alt=""
                    />
                    <div className={styles.text_container}>
                        <h3>Queen of Pentacles</h3>
                        <div className={styles.description_container}>
                            <p>
                                Everyone has their own unique biorhythms, which are
                                unpredictable. So, we update them daily.
                            </p>
                            <div className={styles.button}>
                                <Link to={resultLink} onClick={handleContinue}>🔓 Unlock</Link>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </Page>
    );
};

export {ResultPage};
